import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {TokenUserInfo} from './shared/services/tokenUserInfo.service';
import {FreshpassFaqComponent} from './shared/components/freshpass-faq/freshpass-faq.component';

export const routes: Routes = [

    {
        path: 'freshpass/manage',
        loadChildren: () => import('./components/manage/manage-subscriptions.module').then(m => m.ManageSubscriptionsModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage.html',
        loadChildren: () => import('./components/manage/manage-subscriptions.module').then(m => m.ManageSubscriptionsModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/change',
        loadChildren: () => import('./components/change-plan/change-plan.module').then(m => m.ChangePlanModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/change.html',
        loadChildren: () => import('./components/change-plan/change-plan.module').then(m => m.ChangePlanModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/confirmation',
        loadChildren: () => import('./components/confirmation/confirmation.module').then(m => m.ConfirmationModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/confirmation.html',
        loadChildren: () => import('./components/confirmation/confirmation.module').then(m => m.ConfirmationModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/cancel-plan',
        loadChildren: () => import('./components/cancel-freshpass/cancel-freshpass.module').then(m => m.CancelFreshpassModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/cancel-plan.html',
        loadChildren: () => import('./components/cancel-freshpass/cancel-freshpass.module').then(m => m.CancelFreshpassModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/update-payments',
        loadChildren: () => import('./components/update-payments/update-payments.module').then(m => m.UpdatePaymentsModule),
        resolve: {
            tokenObject: TokenUserInfo
        },
    },
    {
        path: 'freshpass/manage/update-payments.html',
        loadChildren: () => import('./components/update-payments/update-payments.module').then(m => m.UpdatePaymentsModule),
        resolve: {
            tokenObject: TokenUserInfo
        }
    },
    {
        path: 'freshpass/manage/subscribe',
        loadChildren: () => import('./components/registration/registration.module').then(m => m.RegistrationModule),
    },
    {
        path: 'freshpass/manage/subscribe.html',
        loadChildren: () => import('./components/registration/registration.module').then(m => m.RegistrationModule),
    },
    {
        path: 'freshpass/manage/freshpass-faq',
        component: FreshpassFaqComponent
    },
    {
        path: 'freshpass/manage/freshpass-faq.html',
        component: FreshpassFaqComponent
    },
    {
        path: 'freshpass/manage/govassist',
        loadChildren: () => import('./components/snap/snap.module').then(m => m.SnapModule),
    },
    {
        path: 'freshpass/manage/govassist.html',
        loadChildren: () => import('./components/snap/snap.module').then(m => m.SnapModule),
    },
    {
        path: 'freshpass/manage/discount',
        loadChildren: () => import('./components/partners/partners.module').then(m => m.PartnersModule),
    },
    {
        path: 'freshpass/manage/discount.html',
        loadChildren: () => import('./components/partners/partners.module').then(m => m.PartnersModule),
    }];

@NgModule({
    imports: [RouterModule.forRoot(routes,
        {
            scrollPositionRestoration: 'enabled',
            preloadingStrategy: PreloadAllModules
        })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

